/**
 * @fileoverview Helper logging methods that abstract away from the logging
 * services.
 */
import { isDebug } from '@src/helpers';
import { getSentryHub } from './sentryLazy';
/** Log an error to the sentry server. */
export const logError = (error, logToSentry = true) => {
    if (logToSentry) {
        getSentryHub().captureException(error);
    }
    if (isDebug()) {
        console.error(error);
    }
};
/** Log a message to the sentry server. */
export const logMessage = (message, logToSentry = true) => {
    if (logToSentry) {
        getSentryHub().captureMessage(message);
    }
    if (isDebug()) {
        // Debug purposes
        // eslint-disable-next-line no-console
        console.log(message);
    }
};
